import Justin from 'media/justin.png'
import Mike from 'media/mike.png'
import Abe from 'media/abe.png'

export default [
  {
    name: 'Justin Krogue, MD',
    title: 'Co-Founder',
    linkedin: 'https://www.linkedin.com/in/justin-krogue-bb376526/',
    bio: "Justin is an orthopedic surgery resident living in San Francisco. He graduated from BYU and attended medical school at Washington University in St. Louis. He then came to San Francisco to pursue an orthopedic surgery residency at UCSF. Justin became interested in moonlighting by necessity as he tried to support a family on a resident's salary in the Bay Area.",
    image: Justin,
  },
  {
    name: 'Michael Wilson, MD',
    title: 'Co-Founder',
    linkedin: 'https://www.linkedin.com/in/mikebwilsonmd/',
    bio: "Mike went to BYU for undergraduate and Washington University in St. Louis for medical school. Mike is a medical-technology enthusiast and is anxious to improve the system for doctors & patients. He moonlights to provide for his family and fund new ventures.",
    image: Mike,
  },
  {
    name: 'Abe Clark',
    title: 'Co-Founder',
    linkedin: 'https://www.linkedin.com/in/abrahamclark/',
    bio: 'Abe is a software developer & business addict. He graduated from BYU with a degree in finance. He then worked as an Investment Banking Analyst at J.P. Morgan. After banking, Abe spent 9 months learning how to code and then was hired as the first developer at LoanSnap, a company creating fast & fair consumer mortgage loans. Born into a family of doctors, Abe has always been interested in healthcare innovation. When approached by Justin and Mike about the idea of OnCallogy, the need resonated.',
    image: Abe,
  },
]


// WEBPACK FOOTER //
// ./src/lib/team.js